var Vendd = (function (Vendd) {
	"use strict";
	Vendd.ReturnOrder = (function (ReturnOrder) {
		var model = {};
		var observabeItemCollection = [];
		var observableaddress = {};
		var BillingValidationEngine = {};
		var editAddressOpen = false;
		var BankInfo = {};
		ReturnOrder.DeleteSelected = function () {
			var deletedItemRowIds = [];

			for (var i = observabeItemCollection.length - 1; i >= 0; i--) {
				if (observabeItemCollection[i] != undefined && observabeItemCollection[i].Delete) {
					deletedItemRowIds.push.apply(deletedItemRowIds, doDeleteItem(observabeItemCollection[i]));
				}
			}
			return deletedItemRowIds;
		};

		ReturnOrder.DeleteItem = function (rowId) {
			var observableRows = observabeItemCollection.filter(function (item) {
				return item.RowId == rowId;
			});
			if (observableRows[0]) observableRows[0].IsAdded = false;
			return doDeleteItem(observableRows[0]);
		};

		ReturnOrder.SetPayment = function (paymentType) {
			if (paymentType == 'coupon') {

				$.each(observabeItemCollection, function (idx, item) {
					if (item != undefined) {
						item.Credit = true;
						item.Refund = false;
					}
				});
			}
			if (paymentType == 'bank') {
				$.each(observabeItemCollection, function (idx, item) {
					if (item != undefined) {
						item.Credit = false;
						item.Refund = true;
					}
				});
			}
		};

		var doDeleteItem = function (item, keepParent) {
			var returnItemRowIds = [];
			if (!item) return returnItemRowIds;
			if (item.IsSplitted && item.GetModel().Children) {

				for (var i = item.GetModel().Children.length - 1; i >= 0; i--) {
					if (item.GetModel().Children && item.GetModel().Children[i]) {
						returnItemRowIds.push.apply(returnItemRowIds, doDeleteItem(item.GetModel().Children[i]));
					}
				}

			}

			if (item.IsChildElement && item.GetModel() && item.GetModel().Parent && item.GetModel().Parent.GetModel() && item.GetModel().Parent.GetModel().Children) {
				var index = item.GetModel().Parent.GetModel().Children.indexOf(item);
				if (item.GetModel().Parent.GetModel().Children[index]) {
					item.GetModel().Parent.GetModel().Children[index].IsAdded = false;
					item.GetModel().Parent.GetModel().Children[index].IsRemoved = true;
					item.GetModel().Parent.GetModel().Children[index].model.ReturnItemConditionId = 0;
				}
				var activeChildren = item.GetModel().Parent.GetModel().Children.filter(function (x) { return !(x.IsRemoved === true); });
				if (!activeChildren) {
					item.GetModel().Parent.GetModel().IsSplitted = false;
					item.GetModel().Parent.GetModel().ReturnItemConditionId = 0;
					item.GetModel().Parent.GetModel().IsRemoved = true;
					item.GetModel().Parent.GetModel().AvailableQuantityForReturn = item.GetModel().Parent.GetModel().Quantity - item.GetModel().Parent.GetModel().ReturnQuantity;
					if (!keepParent) {
						returnItemRowIds.push(item.GetModel().Parent.GetModel().RowId);
						doDeleteItem(item.GetModel().Parent.GetModel().RowId);
					}
				} else {
					item.GetModel().Parent.GetModel().AvailableQuantityForReturn = activeChildren.length;
				}
				item.GetModel().Parent.NotifyPropertyChanged("AvailableQuantityForReturn", item.GetModel().Parent.GetModel().AvailableQuantityForReturn);
			}
			var ind = observabeItemCollection.indexOf(item);
			if (observabeItemCollection[ind]) {
				observabeItemCollection[ind].model.ReturnItemConditionId = 0;
				observabeItemCollection[ind].IsRemoved = true;
			}
			returnItemRowIds.push(item.RowId);
			return returnItemRowIds;
		};

		ReturnOrder.UnSplit = function (rowid, keepParent) {
			var observableRows = observabeItemCollection.filter(function (item) {
				return item.RowId == rowid;
			});

			var returnItemRowIds = [];

			var observableRow = observableRows[0];
			observableRow.IsSplitted = false;
			observableRow.AvailableQuantityForReturn = observableRow.Quantity - observableRow.ReturnQuantity;
			observableRow.NotifyPropertyChanged("AvailableQuantityForReturn", observableRow.AvailableQuantityForReturn);
			if (observableRow.GetModel().Children == undefined || observableRow.GetModel().Children.length < 2) {
				return returnItemRowIds;
			}
			for (var i = observableRow.GetModel().Children.length - 1; i >= 0; i--) {
				if (observableRow.GetModel().Children && observableRow.GetModel().Children[i] && !observableRow.GetModel().Children[i].IsRemoved) {
					returnItemRowIds.push.apply(returnItemRowIds, doDeleteItem(observableRow.GetModel().Children[i], keepParent));
				}
			}

			return returnItemRowIds;
		};

		ReturnOrder.SelectAll = function (deleteItems) {
			$.each(observabeItemCollection, function (idx, item) {
				if (item != undefined) {
					item.Delete = deleteItems;

				}
			});
		}


		ReturnOrder.Split = function (rowid) {

			var observableRows = observabeItemCollection.filter(function (item) {
				if (item.model.Parent && item.model.Parent.model.RowId == rowid) item.model.IsRemoved = true;
				return item.RowId == rowid;
			});
			var itemChildren = [];
			var observableRow = observableRows[0];
			observableRow.AvailableQuantityForReturn = observableRow.Quantity - observableRow.ReturnQuantity;
			if (observableRow.AvailableQuantityForReturn == 1) {
				return itemChildren;
			}
			for (var i = 0; i < observableRow.AvailableQuantityForReturn; i++) {
				var newOrderitem = jQuery.extend(true, {}, observableRow.GetModel());
				if (newOrderitem.Children) newOrderitem.Children = null;
				newOrderitem.Quantity = 1;
				newOrderitem.AvailableQuantityForReturn = 1;
				newOrderitem.IsSplitted = false;
				newOrderitem.IsRemoved = false;
				newOrderitem.RowId = observabeItemCollection.MaxIndex + 1;
				newOrderitem.IsChildElement = true;
				observabeItemCollection.MaxIndex = newOrderitem.RowId;
				newOrderitem.AvailableConditions = {};
				delete newOrderitem.ValidationEngine;
				var observable = new Vendd.Observable(newOrderitem);

				observable.GetModel().Parent = observableRow;
				observable.GetModel().ValidationEngine = Vendd.ReturnOrder.CreateOrderReturnItemalidationModel(observable);
				itemChildren.push(observable);
				observabeItemCollection.push(observable);
			}
			observableRow.GetModel().Children = itemChildren;
			observableRow.GetModel().IsSplitted = true;

			return itemChildren;
		};

		ReturnOrder.GetReturnOrderCongfigData = function () {
			var configs = {
				UploadServiceUrl: model.UploadServiceUrl
			};
			return configs;
		}

		ReturnOrder.GetObservableItemsCollection = function (refresh) {
			if (observabeItemCollection.length == 0 || refresh) {
				$.each(model.Return.AvailableItemForReturn, function (idx, item) {

					item.Literals2 = model.Return.Literals2;

					delete item.AvailableConditions;
					delete item.ValidationEngine;
					delete item.CouponCodes;
					delete item.Resources;

					var vItem = jQuery.extend(
						true,
						item,
						{ Delete: false },
						{ RowId: idx },
						{ IsSplitted: false },
						{ IsAdded: false },
						{ IsRemoved: false },
						{ Children: null },
						{ IsChildElement: false },
						{ AvailableQuantityForReturn: item.Quantity - item.ReturnQuantity }
					);

					var observable = new Vendd.Observable(vItem);
					observable.GetModel().ValidationEngine = ReturnOrder.CreateOrderReturnItemalidationModel(observable)
					observabeItemCollection.push(observable);
					observabeItemCollection.MaxIndex = idx;
				});
			}
			return observabeItemCollection;
		};

		ReturnOrder.EmptytObservableItemsCollection = function () {
			observabeItemCollection = [];
		};

		ReturnOrder.GetAvailableItemConditions = function () {
			return { AvailableConditions: model.Return.AvailableConditions };
		};

		ReturnOrder.SetResourceForItem = function (rowid, resource) {
			var observableRow = observabeItemCollection.filter(function (item) {
				return item.RowId == rowid;
			});
			var item = observableRow[0].GetModel();
			if (item.Resources == undefined) {
				item.Resources = [];
			}
			item.Resources.push(resource);
		};

		ReturnOrder.GetObservableAddress = function () {
			editAddressOpen = true;
			var address = observableaddress.GetModel();
			address.AddressLine1 = '';
			address.PostCode = '';
			address.Area = '';
			observableaddress = new Vendd.Observable(address);
			return observableaddress;
		};

		ReturnOrder.ResetObservableAddress = function () {
			editAddressOpen = false;
			var clonnedAddress = jQuery.extend(true, {}, model.OrderShippingLocation);
			observableaddress = new Vendd.Observable(clonnedAddress);
			return observableaddress;
		};

		ReturnOrder.GetOrderInfo = function () {
			var orderInfo = {
				Request: {
					OrderInfo: model.OrderInfo,
					OrderShippingLocation: model.OrderShippingLocation,
					OrderItems: model.Return.AvailableItemForReturn,
					PreviousReturns: model.Return.PreviousReturns
				}
			};
			var clonnedAddress = jQuery.extend(true, {}, model.OrderShippingLocation);
			observableaddress = new Vendd.Observable(clonnedAddress);

			return orderInfo;
		};

		ReturnOrder.GetReturnModel = function () {

			BankInfo = new Vendd.Observable({ IBAN: "", Bank: "", Beneficiary: "" });

			return BankInfo;
		};

		Vendd.MessageBus.subscribe(
			Vendd.ReturnOrder.Messages.SubmitOrderReturn,
			"ReturnOrder",
			function (envelope) {
				var submitOrderItems = [];
				var submittedItems = observabeItemCollection.filter(function (x) {
					x.model.Children = x.model.Children.filter(function (y) {
						return y.IsAdded;
					});
					return x.IsAdded == true;
				});
				$.each(submittedItems, function (idx, item) {
					item.model.__type = "RequestItemViewModel:#Lighthouse.Lh3.FrontEnd.Root.Model";
					if (item.IsSplitted != undefined && item.IsSplitted == false) {
						item.GetModel().Parent = undefined;

						var valOptions = {
							ValidationEngine: item.GetModel().ValidationEngine,
							valmodel: item.GetModel(),
						};

						Vendd.DataValidation.ValidateModel(valOptions);

						submitOrderItems.push(item.GetModel());
					}
				});

				if (submitOrderItems[0].Refund) {

					var valBillOptions = {
						ValidationEngine: BillingValidationEngine,
						valmodel: BankInfo.GetModel(),
					};
					Vendd.DataValidation.ValidateModel(valBillOptions);
				}

				if (editAddressOpen) {

					Vendd.Account.ValidateObservable();
				}

				var submitData = {
					OrderInfo: { OrderId: model.OrderInfo.OrderId },
					OrderShippingLocation: observableaddress.GetModel(),
					Return: {
						IBAN: BankInfo.IBAN,
						Bank: BankInfo.Bank,
						Beneficiary: BankInfo.Beneficiary,
						ReturnItems: submitOrderItems
					}
				};

				var options = {
					url: "ReturnOrderService.svc/RequestOrderSubmit",
					data: {
						RequestReturnInfo: submitData
					},
					onSuccess: onSuccess,
					onFailure: onFailure
				};

				function onSuccess(response) {
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.SubmitOrderReturnSuccess(response)
					);
				}

				function onFailure(response) {
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.SubmitOrderReturnsFailed(response)
					);
				}

				Vendd.Service.call(options);
			}
		);


		ReturnOrder.CreateOrderBillingValidationModel = function (observable) {

			var defaultValidationModel = {
				IBAN: [{ rule: "required" }],
				Bank: [{ rule: "required" }],
				Beneficiary: [{ rule: "required" }]
			};

			var valEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

			var propertyChanging = function propertyChanging(data, propertyName, value) {

				var valOptions = {
					ValidationEngine: valEngine,
					PropertyName: propertyName,
					PropertyValue: value
				};
				Vendd.DataValidation.Validate(valOptions);
			};

			var customReturnValidationModel = ({
				IBAN: [{ rule: "isIbanCorrect" }],

			});

			var isIbanCorrect = function (value) {
				if (value.length > 27 || value.length < 27) {
					return false;
				}
				return true;
			};

			valEngine.addOrUpdateValidationRule('isIbanCorrect', isIbanCorrect, 'Iban must be Shorter than 27 characters');
			valEngine.updateValidationModel(customReturnValidationModel);

			observable.AddListenerToPropertyChanging('IBAN', propertyChanging);
			observable.AddListenerToPropertyChanging('Bank', propertyChanging);
			observable.AddListenerToPropertyChanging('Beneficiary', propertyChanging);
			BillingValidationEngine = valEngine;
			return BillingValidationEngine;
		};

		ReturnOrder.DestroyBillingValidationModel = function (observable) {

		}

		ReturnOrder.CreateOrderReturnItemalidationModel = function (observable) {

			var defaultValidationModel = {
				ReturnItemConditionId: [{ rule: "required" }],

			};

			var valEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

			var customReturnValidationModel = ({
				ReturnItemConditionId: [{ rule: "IsPhotoRequired" }, { rule: "mustHaveCondition" }],

			});

			var mustHaveCondition = function (value) {
				if (value == 0) {
					return false
				}

				return true;
			};

			var IsPhotoRequired = function (value) {
				if (value == 5 || value == 0 || value == 4) {
					return true;
				}
				if (observable.GetModel().Resources != undefined && observable.GetModel().Resources.length > 0) {
					return true;
				}
				return false;
			};

			valEngine.addOrUpdateValidationRule('IsPhotoRequired', IsPhotoRequired, 'This Condition is requires an Image');
			valEngine.addOrUpdateValidationRule('mustHaveCondition', mustHaveCondition, 'All items must have a condition');

			valEngine.updateValidationModel(customReturnValidationModel);

			return valEngine;
		};


		Vendd.MessageBus.subscribe(
			Vendd.ReturnOrder.Messages.GetRequestReturn,
			"ReturnOrder",
			function (envelope) {
				var options = {
					url: "ReturnOrderService.svc/GetReturnRequestOrderData",
					data: {
						orderid: envelope.message.data
					},
					onSuccess: onSuccess,
					onFailure: onFailure
				};

				function onSuccess(response) {
					model = response;
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.GetRequestReturnSuccess(response)
					);
				}

				function onFailure(response) {
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.GetRequestReturnFailure(response)
					);
				}

				Vendd.Service.call(options);
			}
		);

		Vendd.MessageBus.subscribe(
			Vendd.ReturnOrder.Messages.ValidateOrderContactInfo,
			"ReturnOrder",
			function (envelope) {
				var options = {
					url: "ReturnOrderService.svc/ValidateOrderContactInfo",
					data: envelope.message.data,
					onSuccess: onSuccess,
					onFailure: onFailure
				};

				function onSuccess(response) {
					model = response;
					if (response.d == 0) {
						Vendd.MessageBus.publishAsync(
							"ReturnOrder",
							new Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelFailure(
								response
							)
						);

					}
					else {
						Vendd.MessageBus.publishAsync(
							"ReturnOrder",
							new Vendd.ReturnOrder.Messages.ValidateOrderContactInfoSuccess(
								response
							)
						);
					}
				}

				function onFailure(response) {
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.ValidateOrderContactInfoFailure(
							response
						)
					);
				}

				Vendd.Service.call(options);
			}
		);

		Vendd.MessageBus.subscribe(
			Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModel,
			"ReturnOrder",
			function (envelope) {
				var options = {
					url: "ReturnOrderService.svc/GetReturnRequestValidationFormModel",
					data: envelope.message.data,
					onSuccess: onSuccess,
					onFailure: onFailure
				};

				function onSuccess(response) {
					model = response;
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelSuccess(
							response
						)
					);
				}

				function onFailure(response) {
					Vendd.MessageBus.publishAsync(
						"ReturnOrder",
						new Vendd.ReturnOrder.Messages.GetReturnRequestValidationFormModelFailure(
							response
						)
					);
				}

				Vendd.Service.call(options);
			}
		);

		Vendd.MessageBus.subscribe(
			Vendd.ReturnOrder.Messages.GetReturnedOrdersModel,
			"ReturnedOrder",
			function (envelope) {
				var options = {
					url: "ReturnOrderService.svc/GetUserReturnRequests",
					data: envelope.message.data,
					onSuccess: onSuccess,
					onFailure: onFailure
				};

				function onSuccess(response) {
					model = response;
					Vendd.MessageBus.publishAsync(
						"ReturnedOrder",
						new Vendd.ReturnOrder.Messages.GetReturnedOrdersModelSuccess(
							response
						)
					);
				}

				function onFailure(response) {
					Vendd.MessageBus.publishAsync(
						"ReturnedOrder",
						new Vendd.ReturnOrder.Messages.GetReturnedOrdersModelFailure(
							response
						)
					);
				}

				Vendd.Service.call(options);
			}
		);

		return ReturnOrder;
	})(Vendd.ReturnOrder || {});

	return Vendd;
})(Vendd || {});
